import { useEmbarcacaoTanques } from "../../../../hooks/use-embarcacao-tanques";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  TANQUES_EMPTY_STATE,
  TANQUES_FIELDS,
  TANQUES_ID,
  TANQUES_LOADING_MESSAGE,
  TANQUES_TEST_ID,
  TANQUES_TITLE,
} from "./tanques-section.constants";

/** Seção Tanques do detalhamento da embarcação, somente para consulta: campos já formatados na ordem da tela; campo sem valor mostra "Campo sem preenchimento". */
export function useTanquesSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, tanques, errorMessage, reload } = useEmbarcacaoTanques(embarcacaoId);

  return {
    id: TANQUES_ID,
    title: TANQUES_TITLE,
    testId: TANQUES_TEST_ID,
    fieldsTestId: `${TANQUES_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: TANQUES_LOADING_MESSAGE,
    emptyContent: TANQUES_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: tanques
      ? latestAtualizacao([tanques.ultimaAtualizacao, tanques.atualizacaoCapacidade])
      : undefined,
    fields: buildDetailFields(tanques, TANQUES_FIELDS, TANQUES_TEST_ID, EMPTY_FIELD_PLACEHOLDER),
  };
}
